import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { postRedDotReadApi } from '@flipster/apis/v1/red-dot';

export function useUpdateRedDotMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ gnb }: { gnb: string }) => postRedDotReadApi({ gnb }),
    onSuccess: (_, { gnb }) => {
      queryClient.invalidateQueries({ queryKey: ['getRedDotApi'] });
      if (gnb === 'REWARD_HUB') queryClient.invalidateQueries({ queryKey: ['getRewardHubTooltipApi'] });
    },
  });
}
